import { IMultiValuedFilter } from "./IMultiValuedFilter";
import FilterQuery, { Operator } from "../queries/FilterQuery";
import OrQuery from "../queries/OrQuery";

export default class EnumFilter implements IMultiValuedFilter {
  attribute: string;
  values: string[];

  constructor(attribute: string, values: string[]) {
    this.attribute = attribute;
    this.values = values;
  }

  toQuery() {
    return new OrQuery(
      this.values.map((value) => new FilterQuery(this.attribute, Operator.EQUAL, value))
    );
  }
}
